export const CANVAS_SIZE = 2500;

export const ZOOM_LEVELS = [0.25, 1 / 3, 0.5, 2 / 3, 0.75, 1, 1.25, 1.5];
export const DEFAULT_ZOOM_LEVEL = ZOOM_LEVELS.indexOf(1);

export const MAX_LABEL_LENGTH = 40;
export const MAX_NAME_LENGTH = 40;
